import { AppLogger } from '../src/AppLogger'

const logger = AppLogger.getInstance()
export const setAccessToken = (token: string) => {
  logger.log(`setAccessToken :${token}`)
  if (token && token.trim().length > 0) {
    window.sessionStorage.setItem('accessToken', token)
  } else {
    window.sessionStorage.removeItem('accessToken')
  }
}

export const getAccessToken = () => {
  const _token = window.sessionStorage.getItem('accessToken')
  const _accessToken = _token ? _token : ''
  logger.log(`getAccessToken:${_accessToken}`)
  return _accessToken
}
